// extracted by css-extract-rspack-plugin
export default {"textCardStyled":"LkLOp"};